import { CurrencyDropdown, LanguageDropdown } from "@/common";
import Button from "@/common/atoms/Button";
import { resetError } from "@/features/auth/duck/auth";
import { showModal } from "@/store/slices/modalSlice";
import LoginModal from "@/features/auth/login/LoginModal";
import SignupModal from "@/features/auth/signup/SignUp";
import { useTranslation } from "react-i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import LoggedInUserMenu from "./LoggedInUserMenu";

const TopNavbar = ({ isMobile }) => {
  // TODO: remove commit
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isLogin, userInfo } = useSelector(
    (state) => ({
      isLogin: state.auth.isLogin,
      userInfo: state.user.userInfo
    }),
    shallowEqual
  );

  const showLoginModal = () => {
    dispatch(resetError());
    dispatch(
      showModal({
        content: <LoginModal />,
        classes: "login-modal-container"
      })
    );
  };
  const showSignUpModal = () => {
    dispatch(resetError());
    dispatch(
      showModal({
        content: <SignupModal />,
        classes: "sign-up-modal-container"
      })
    );
  };

  const userIsLoggedIn = isLogin && userInfo;

  return (
    <div
      className={`${
        isMobile
          ? "bg-gradient-to-r !from-[#5e8260] !to-[#466150] px-6 py-10"
          : "bg-secondary px-4 py-3"
      } w-full`}>
      <div className="mx-auto w-full max-w-screen-xl">
        <div
          className={`flex ${
            !userIsLoggedIn && "flex-col"
          } lg:flex-row justify-start lg:justify-end gap-4`}>
          {!isMobile && (
            <div className="flex items-center justify-start lg:justify-end gap-2">
              <LanguageDropdown className="custom-select-currency" />
              <CurrencyDropdown className="custom-select-currency" />
            </div>
          )}
          {userIsLoggedIn ? (
            <div className="flex items-center justify-end gap-4">
              <LoggedInUserMenu isMobile={isMobile} />
            </div>
          ) : (
            <div className="flex items-center justify-start lg:justify-end gap-2">
              <Button
                type="solid"
                className="bg-secondary"
                onClick={showLoginModal}>
                {t("common.login")}
              </Button>
              <Button type="solid" onClick={showSignUpModal}>
                {t("common.signup")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
